import { defineAction } from '~/prix'
import actionJson from './privateFileConfirmUpload.action.json' with { type: 'json' }
import { z } from 'zod'
import { privateFileObject } from '../privateFileObject'

const privateFileConfirmUploadDefinition = defineAction({
  ...actionJson,
  input: z.object({
    fileId: z.string().uuid(),
  }),
  output: privateFileObject,
})

export default privateFileConfirmUploadDefinition
